export default __webpack_public_path__ + "static/media/ANALISIS_PRECISO_ICON.3866fddb.svg";